import React, { ComponentProps, Fragment } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { useRouter } from 'next/router';
import { ChildcareLayerContainer } from 'Components/widgets/childcare-layer/ChildcareLayer.container';
import { EsfLayer } from 'Components/widgets/esf-layer/EsfLayer';
import { InsuranceLayerConnected } from 'Components/widgets/layer-insurance/InsuranceLayer';
import { PackagesLayer } from 'Components/widgets/packages-layer/PackagesLayer';
import { TransfersLayerContainer } from 'Components/widgets/transfers-layer/TransfersLayer.container';
import { TRACK_PAGE_NAMES } from 'Tracking/constants';
import { getReferenceType } from 'Tracking/utils';
import { StayRentalsBooking } from 'Components/widgets/rentals-booking/StayRentalsBooking';
type Props = {
  bookings: ReadonlyArray<BookingEntity>;
  forwardRef: ReactRef;
};
export const UpsellsServicesLayers = ({ bookings, forwardRef }: Props) => {
  const router = useRouter();
  const { query: queryParams } = router;
  const booking = bookings.filter(Boolean).find(({ id }) => id === queryParams.id);
  const stay = (booking?.stays || []).find(({ id }) => id === queryParams.stayId);
  if (!queryParams.id || !booking || !stay) {
    return null;
  }
  const trackingPayload = (name: string) => ({
    pageName: name,
    payload: {
      reference_id: booking.id,
      reference_type: getReferenceType(booking?.status?.name),
    },
  });
  return bookings.length > 0 ? (
    <Fragment>
      <ChildcareLayerContainer
        {...asWidgetProps<ComponentProps<typeof ChildcareLayerContainer>>({
          forwardRef: forwardRef,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_CHILDCARE),
        })}
      />
      <EsfLayer
        {...asWidgetProps<ComponentProps<typeof EsfLayer>>({
          forwardRef: forwardRef,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_ESF),
        })}
      />
      <InsuranceLayerConnected
        {...asWidgetProps<ComponentProps<typeof InsuranceLayerConnected>>({
          forwardRef: forwardRef,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_INSURANCE),
        })}
      />
      <PackagesLayer
        {...asWidgetProps<ComponentProps<typeof PackagesLayer>>({
          forwardRef: forwardRef,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_JOYVIEW),
        })}
      />
      <StayRentalsBooking
        {...asWidgetProps<ComponentProps<typeof StayRentalsBooking>>({
          forwardRef: forwardRef,
          hasLayerOnly: true,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_RENTALS),
        })}
      />
      <TransfersLayerContainer
        {...asWidgetProps<ComponentProps<typeof TransfersLayerContainer>>({
          forwardRef: forwardRef,
          stay: stay,
          tracking: trackingPayload(TRACK_PAGE_NAMES.CA_LAYER_TRANSFER),
        })}
      />
    </Fragment>
  ) : null;
};
